import {BankAccountResponseBody} from '@dms/api/shared';

import {getDefaultDomainBankAccount, getDomainBankAccounts} from './getDomainBankAccounts';

/**
 * Returns bank accounts valid for the AFTS domain.
 *
 * When the domain system is active (at least one account carries a domain tag),
 * only AFTS-tagged accounts and untagged accounts are returned.
 */
export function getAftersalesBankAccounts(accounts: BankAccountResponseBody[]) {
  return getDomainBankAccounts(accounts, 'AFTS');
}

/**
 * Returns default bank account for the AFTS domain.
 *
 * Priority:
 * 1. Currency-matching AFTS account (if currency provided)
 * 2. Primary AFTS account
 * 3. First AFTS account
 *
 * Falls back through the same priority for untagged accounts when no domain system is active.
 */
export function getDefaultAftersalesBankAccount(
  accounts: BankAccountResponseBody[],
  currency?: string
) {
  return getDefaultDomainBankAccount(accounts, 'AFTS', currency);
}
